import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _badge = { functionUpdateDate: 'google.protobuf.Timestamp' };
var _bulkCancelEventsRequest = {};
var _bulkCancelEventsResponse = {};
var _bulkDeleteEventsRequest = {};
var _bulkDeleteEventsResponse = {};
var _cancelEventRequest = {};
var _cancelEventResponse = { event: '_event' };
var _category = { createdDate: 'google.protobuf.Timestamp' };
var _copyEventRequest = {};
var _copyEventResponse = { event: '_event' };
var _copyEventV2Request = {
    fields: 'google.protobuf.FieldMask',
    event: '_eventData',
};
var _copyEventV2Response = { event: '_event' };
var _createEventV2Request = { event: '_eventData' };
var _createEventV2Response = { event: '_event' };
var _deleteEventRequest = {};
var _deleteEventResponse = {};
var _design = { poll: '_pollDesign' };
var _event = {
    created: 'google.protobuf.Timestamp',
    modified: 'google.protobuf.Timestamp',
    publishedDate: 'google.protobuf.Timestamp',
    location: '_location',
    scheduling: '_scheduling',
    mainImage: '_image',
    registration: '_registration',
    categories: '_category',
    longDescription: '_richContent',
    badges: '_badge',
};
var _eventData = {
    location: '_location',
    scheduleConfig: '_scheduleConfig',
    mainImage: '_image',
    rsvpCollectionConfig: '_rsvpCollectionConfig',
    longDescription: '_richContent',
};
var _findEventRequest = {};
var _findEventResponse = { event: '_event' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getEventRequest = {};
var _getEventResponse = { event: '_event' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageData = { image: '_media' };
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _listCategoryEventsRequest = {};
var _listCategoryEventsResponse = { events: '_event' };
var _listEventsRequest = {};
var _listEventsResponse = { events: '_event' };
var _location = { coordinates: '_mapCoordinates', fullAddress: '_address' };
var _mapCoordinates = { lat: 'DOUBLE', lng: 'DOUBLE' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _occurrence = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _publishDraftEventRequest = {};
var _publishDraftEventResponse = { event: '_event' };
var _queryEventsRequest = {};
var _queryEventsResponse = { events: '_event' };
var _queryEventsV2Request = {};
var _queryEventsV2Response = { events: '_event' };
var _recurrences = { occurrences: '_occurrence' };
var _registration = { rsvpCollection: '_rsvpCollection' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _rsvpCollection = { config: '_rsvpCollectionConfig' };
var _rsvpCollectionConfig = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _scheduleConfig = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    recurrences: '_recurrences',
};
var _scheduling = { config: '_scheduleConfig' };
var _updateEventRequest = {
    fields: 'google.protobuf.FieldMask',
    event: '_eventData',
};
var _updateEventResponse = { event: '_event' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
function resolveWixEventsEventManagementUrl(opts) {
    var domainToMappings = {
        'events._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
        ],
        'www.wixevents.com': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/api',
                destPath: '/api',
            },
            {
                srcPath: '/viewEvent',
                destPath: '/viewEvent',
            },
            {
                srcPath: '/viewRsvpDashboard',
                destPath: '/viewRsvpDashboard',
            },
            {
                srcPath: '/viewOrderDashboard',
                destPath: '/viewOrderDashboard',
            },
            {
                srcPath: '/viewSummarySubscription',
                destPath: '/viewSummarySubscription',
            },
            {
                srcPath: '/check-in',
                destPath: '/check-in',
            },
            {
                srcPath: '/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/export',
                destPath: '/export',
            },
            {
                srcPath: '/tickets',
                destPath: '/tickets',
            },
            {
                srcPath: '/payment-redirect',
                destPath: '/payment-redirect',
            },
            {
                srcPath: '/admin',
                destPath: '/admin',
            },
            {
                srcPath: '/ticket',
                destPath: '/ticket',
            },
            {
                srcPath: '/media',
                destPath: '/media',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-events-web',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/events/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/events/v1/reports',
                destPath: '/v1/reports',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/web',
                destPath: '/v1/web',
            },
            {
                srcPath: '/events/v2/tickets',
                destPath: '/v2/tickets',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/events/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a list of up to 1,000 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
 * @deprecated It has been replaced with wix.events.EventManagement.QueryEventsV2(), and will be removed on 2022-06-11.
 */
export function query(payload) {
    var _a = serializer(_queryEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryEventsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __query(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.Query',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __query.fromReq = fromReq;
    __query.__isAmbassador = true;
    return __query;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves a list of up to 1,000 events, given the provided paging, filtering and sorting.
 *
 * ** Important **:
 * - All results are for one specific business, resolved from the request context.
 *
 * Query object support:
 * - `filter` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
 * - `sort` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
 * - `paging` - supported, see [paging](https://dev.wix.com/api/rest/getting-started/pagination).
 * - `fields` - not supported.
 * - `fieldsets` - not supported, use request-level `fieldset` instead.
 * - `cursorPaging` - not supported, use offset pagination instead.
 *
 * Defaults:
 * - When filter is not specified, returns all events that caller is authorized to read.
 * - When sorting is not specified, defaults to `created` in `DESC` order.
 * - When limit is not specified, defaults to 0.
 */
export function queryEventsV2(payload) {
    var _a = serializer(_queryEventsV2Request, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryEventsV2Response, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __queryEventsV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.QueryEventsV2',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v2/events/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryEventsV2.fromReq = fromReq;
    __queryEventsV2.__isAmbassador = true;
    return __queryEventsV2;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves a list of up to 100 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering & sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
 *
 * > **Note:**
 * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function listEvents(payload) {
    var _a = serializer(_listEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __listEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'GET',
            methodFqn: 'wix.events.EventManagement.ListEvents',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEvents.fromReq = fromReq;
    __listEvents.__isAmbassador = true;
    return __listEvents;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves a list of up to 100 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination) and category_id.
 * Events are sorted by the sort index defined by CategoryManagement.
 * > **Note:**
 * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function listCategoryEvents(payload) {
    var _a = serializer(_listCategoryEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCategoryEventsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __listCategoryEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'GET',
            methodFqn: 'wix.events.EventManagement.ListCategoryEvents',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/category/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCategoryEvents.fromReq = fromReq;
    __listCategoryEvents.__isAmbassador = true;
    return __listCategoryEvents;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Get Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/get-event) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves an event by ID or URL slug.
 */
export function getEvent(payload) {
    var _a = serializer(_getEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEventResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'GET',
            methodFqn: 'wix.events.EventManagement.GetEvent',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/event',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixEventsEventManagementUrl({
                        protoPath: '/v1/events/event',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getEvent.fromReq = fromReq;
    __getEvent.__isAmbassador = true;
    return __getEvent;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Get Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/get-event) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Finds an event by ID or URL slug. In contrast to Get Event endpoint which returns not found error,
 * Find Event returns empty response when an event is not found.
 *
 * > **Note:**
 * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function findEvent(payload) {
    var _a = serializer(_findEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_findEventResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __findEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'GET',
            methodFqn: 'wix.events.EventManagement.FindEvent',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/event/find',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __findEvent.fromReq = fromReq;
    __findEvent.__isAmbassador = true;
    return __findEvent;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Create Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/create-event) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Creates a new event, with a default registration form in the given language.
 * Default registration form includes first name, last name, and email inputs.
 * To learn more about registration form and customize it, see [Registration Form](https://dev.wix.com/api/rest/wix-events/wix-events/registration-form/about-the-registration-form-api).
 * The event is automatically configured to send daily summary reports of new registrations to site business email.
 * RegistrationConfig.initialType is required - allowed value when creating is RSVP or TICKETS.
 */
export function createEventV2(payload) {
    var _a = serializer(_createEventV2Request, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _eventData: _eventData,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _richContent: _richContent,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createEventV2Response, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __createEventV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.CreateEventV2',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v2/events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createEventV2.fromReq = fromReq;
    __createEventV2.__isAmbassador = true;
    return __createEventV2;
}
/**
 * Copies an event, including its registration form, notifications and tickets configuration - scheduled two weeks from the original event.
 * Multilingual translations are also copied to the new event.
 *
 * When an event with same title already exists, appends (1), (2), ... to it. For example, copying an event titled "My Event" creates "My Event (1)".
 * Very long event titles are cropped: "Daily stand-up ev... (2)".
 * @deprecated It has been replaced with wix.events.EventManagement.CopyEventV2(), and will be removed on 2022-06-11.
 */
export function copy(payload) {
    var _a = serializer(_copyEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_copyEventResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __copy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.Copy',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{eventId}/copy',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __copy.fromReq = fromReq;
    __copy.__isAmbassador = true;
    return __copy;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Clone Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/clone-event) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Copies an event, including its registration form, notifications and tickets configuration - scheduled two weeks from the original event.
 * Multilingual translations are also copied to the new event.
 * Supports partial update of the original event fields. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information.
 *
 * When an event with same title already exists, appends (1), (2), ... to it. For example, copying an event titled "My Event" creates "My Event (1)".
 * Very long event titles are cropped: "Daily stand-up ev... (2)".
 */
export function copyEventV2(payload) {
    var _a = serializer(_copyEventV2Request, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _eventData: _eventData,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _richContent: _richContent,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_copyEventV2Response, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __copyEventV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.CopyEventV2',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v2/events/{id}/copy',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __copyEventV2.fromReq = fromReq;
    __copyEventV2.__isAmbassador = true;
    return __copyEventV2;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Update Event](https://dev.wix.com/docs/rest/business-solutions/events/events/event/update-event) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Updates an event's parameters. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information.
 */
export function updateEvent(payload) {
    var _a = serializer(_updateEventRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _eventData: _eventData,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _richContent: _richContent,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateEventResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __updateEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'PATCH',
            methodFqn: 'wix.events.EventManagement.UpdateEvent',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateEvent.fromReq = fromReq;
    __updateEvent.__isAmbassador = true;
    return __updateEvent;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Update Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/publish-draft-event) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Publishes draft event so that it becomes available to site visitors.
 * If recurring events are set, category with state RECURRING_EVENT will be created.
 * All recurring events will be assigned to this category.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function publishDraftEvent(payload) {
    var _a = serializer(_publishDraftEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishDraftEventResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __publishDraftEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.PublishDraftEvent',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{id}/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishDraftEvent.fromReq = fromReq;
    __publishDraftEvent.__isAmbassador = true;
    return __publishDraftEvent;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Cancel Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/cancel-event) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Cancels an event and closes registration.
 * If event cancellation notifications are enabled, canceling an event automatically sends cancellation emails and/or push notifications to registered guests.
 */
export function cancelEvent(payload) {
    var _a = serializer(_cancelEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelEventResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _category: _category,
        _design: _design,
        _event: _event,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapCoordinates: _mapCoordinates,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpCollection: _rsvpCollection,
        _rsvpCollectionConfig: _rsvpCollectionConfig,
        _scheduleConfig: _scheduleConfig,
        _scheduling: _scheduling,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __cancelEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.CancelEvent',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelEvent.fromReq = fromReq;
    __cancelEvent.__isAmbassador = true;
    return __cancelEvent;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Bulk Cancel Events By Filter](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/bulk-cancel-events-by-filter) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Cancels events by filter.
 * If event cancellation notifications are enabled, canceling an event automatically sends cancellation emails and/or push notifications to registered guests.
 *
 * > **Note:**
 * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function bulkCancelEvents(payload) {
    var _a = serializer(_bulkCancelEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCancelEventsResponse, {}).fromJSON;
    function __bulkCancelEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.BulkCancelEvents',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/bulk/events/cancel-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCancelEvents.fromReq = fromReq;
    __bulkCancelEvents.__isAmbassador = true;
    return __bulkCancelEvents;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Delete Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/delete-event) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Deletes an event.
 * Deleted events are not returned via API. The only way to retrieve them is via GDPR access request.
 */
export function deleteEvent(payload) {
    var _a = serializer(_deleteEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteEventResponse, {}).fromJSON;
    function __deleteEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'DELETE',
            methodFqn: 'wix.events.EventManagement.DeleteEvent',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteEvent.fromReq = fromReq;
    __deleteEvent.__isAmbassador = true;
    return __deleteEvent;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Events V3's [Bulk Delete Events By Filter](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/bulk-delete-events-by-filter) and will be removed on November 6, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Deletes events by filter.
 * Deleted events are not returned via API. The only way to retrieve them is via GDPR access request.
 *
 * > **Note:**
 * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function bulkDeleteEvents(payload) {
    var _a = serializer(_bulkDeleteEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteEventsResponse, {}).fromJSON;
    function __bulkDeleteEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.event',
            method: 'POST',
            methodFqn: 'wix.events.EventManagement.BulkDeleteEvents',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/bulk/events/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteEvents.fromReq = fromReq;
    __bulkDeleteEvents.__isAmbassador = true;
    return __bulkDeleteEvents;
}
//# sourceMappingURL=http.impl.js.map